import React from 'react';
import imageScreenshot from '../phone_usecase_cropped2.png';
import './HowItWorks.css';

// Shared with /how so existing bookmarks still show the same guide.
export default function HowItWorks({ headingTag: Heading = 'h2' }) {
  return (
    <section id="howitworks" className="agreementOverview agreementHomeInner howItWorks" aria-labelledby="how-it-works-title">
      <div id="whatisatstake" className="agreementEyebrow">How it works</div>
      <Heading id="how-it-works-title">How agreements work</Heading>
      <p className="howItWorksIntro">From agreeing on the details to distributing funds, here’s how an Atstake contract works.</p>
      <div className="howItWorksLayout">
        <ol className="howItWorksSteps">
          <li>
            <span className="agreementStepNumber" aria-hidden="true">01</span>
            <div>
              <h3>Agree to terms</h3>
              <p>Choose someone you want to make an agreement with. Write down the terms and send a proposal for review.
                The other person can approve, reject, or suggest edits.</p>
            </div>
          </li>
          <li>
            <span className="agreementStepNumber" aria-hidden="true">02</span>
            <div>
              <h3>Deposit funds to the blockchain</h3>
              <p>Once the terms are agreed, the contract is deployed to Ethereum. One or both people deposit funds,
                according to the agreement. On-chain transactions require network fees.</p>
            </div>
          </li>
          <li>
            <span className="agreementStepNumber" aria-hidden="true">03</span>
            <div>
              <h3>Report the outcome</h3>
              <p>Report what happened to the blockchain. If you disagree, either person can request a decision from
                the agreed arbitrator. Learn about the <a className="agreementTextLink" href="/incentives">escrow and incentives</a>.</p>
            </div>
          </li>
          <li>
            <span className="agreementStepNumber" aria-hidden="true">04</span>
            <div>
              <h3>Funds are distributed</h3>
              <p>The contract’s code distributes funds according to its terms and the reported outcome.</p>
            </div>
          </li>
        </ol>
        <figure className="howItWorksExample">
          <img src={imageScreenshot} width="735" height="1462" alt="Example Atstake agreement on a phone, showing the other party, each person’s deposit, and the written terms." />
          <figcaption>Example contract terms and deposits</figcaption>
        </figure>
      </div>
      <div className="agreementLearnMore">
        <p>For freelance work, a shared goal, or an agreement of your own.</p>
        <a className="agreementTextLink" href="/examples">Explore example agreements <span aria-hidden="true">→</span></a>
      </div>
    </section>
  );
}
